import React from 'react';
import { withRouter } from 'react-router-dom';

//HELPERS
import $ from 'jquery';
import * as c from '../helpers/constants'

//REDUX
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { authActionPrivate } from '../store/auth';

//TOASTER
import { ToastContainer, Slide } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

//COMPONENTS
import Error404 from '../pages/error404';
import Header from '../components/header';
import Footer from '../components/footer';
import {Wrapper} from '../components/inspinia';

class PrivateLayout extends React.PureComponent
{
    constructor(props)
    {
        super(props);

        document.body.style = 'background: #f6f6f6;';
    }

    static defaultProps = 
    {
        navActiveItem: ""
    };

    render()
    {
        const auth = this.props.auth;

        if (auth.isLoading === false && auth.isAuthenticated === false) return ( <Error404 /> );

        return (
            <div id="wrapper" style={{backgroundColor: "#ffffff"}}>
                <div id="page-wrapper" className="gray-bg" style={{margin: "0px 128px"}}>
                    
                    <ToastContainer newestOnTop hideProgressBar autoClose={2000} transition={Slide} toastClassName="toast" />

                    <Header navActiveItem={this.props.navActiveItem} />

                    <Wrapper>
                        {this.props.children}
                    </Wrapper>

                    { <Footer /> }

                </div>
            </div>
        );
    }
}

function mapStateToProps(state)
{
    return { auth: state.auth };
}
function mapDispatchToProps(dispatch)
{
    return {
        actions: {
            auth: bindActionCreators(authActionPrivate, dispatch)
        }
    };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PrivateLayout));
